import { render, staticRenderFns } from "./StatsInfo.vue?vue&type=template&id=5d94710a&scoped=true"
import script from "./StatsInfo.vue?vue&type=script&lang=ts"
export * from "./StatsInfo.vue?vue&type=script&lang=ts"
import style0 from "./StatsInfo.vue?vue&type=style&index=0&id=5d94710a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d94710a",
  null
  
)

export default component.exports